module.exports = __webpack_public_path__ + "img/boxy_background_2.f437cabc.jpg";